import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft, ShoppingBag } from "lucide-react";
import Nav from "@/components/Nav";
import PageBackground, { PageFooter } from "@/components/PageBackground";

export default function Store() {
  return (
    <main
      data-testid="store-page"
      className="relative flex min-h-screen w-full flex-col overflow-hidden text-slate-900"
      style={{
        background:
          "linear-gradient(135deg, #FFF6F7 0%, #FDF8F5 40%, #FFEEF1 100%)",
      }}
    >
      <PageBackground />
      <Nav activePath="/store" />

      <section
        data-testid="store-section"
        className="relative z-10 mx-auto flex w-full max-w-2xl flex-1 flex-col items-center justify-center px-5 py-16 text-center md:px-12 md:py-24 lg:px-16"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex h-20 w-20 items-center justify-center rounded-full border border-white/60 bg-white/70 shadow-[0_10px_30px_rgba(244,63,94,0.18)] backdrop-blur-2xl backdrop-saturate-150"
          data-testid="store-icon"
        >
          <ShoppingBag className="h-8 w-8 text-rose-500" strokeWidth={1.6} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-6 inline-flex items-center gap-2 rounded-full border border-rose-200/70 bg-rose-50/80 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.22em] text-rose-600"
        >
          Coming Soon
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25, ease: "easeOut" }}
          className="font-display mt-6 text-3xl font-light leading-tight tracking-tight text-slate-900 sm:text-4xl md:text-5xl"
          data-testid="store-message"
        >
          The store is not yet
          <span className="relative ml-2 italic text-rose-500">
            available
            <span className="absolute -bottom-1 left-0 h-[3px] w-full rounded-full bg-rose-300/60" />
          </span>
          .
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="mt-5 max-w-md text-sm font-light leading-relaxed text-slate-600 md:text-base"
        >
          Check back soon — merch, prints, and racing essentials are on their
          way to the grid.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.55 }}
          className="mt-10"
        >
          <Link
            to="/"
            data-testid="back-home-link"
            className="group inline-flex items-center gap-2 rounded-full border border-slate-900/15 bg-white/60 px-6 py-3 text-sm font-medium text-slate-800 backdrop-blur-md transition-all duration-300 hover:-translate-y-0.5 hover:border-rose-300/60 hover:bg-white/90 hover:text-rose-600"
          >
            <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-0.5" />
            Back to home
          </Link>
        </motion.div>
      </section>

      <PageFooter />
    </main>
  );
}
